module.exports = __webpack_public_path__ + "img/nathalie_flower_field.d5ab3641.webp";